/* eslint-disable  @typescript-eslint/no-explicit-any */
/* eslint-disable  @typescript-eslint/no-empty-function, @angular-eslint/no-output-native, @angular-eslint/prefer-inject */
/* eslint-disable   @typescript-eslint/no-unused-expressions */

import {
  Component,
  EventEmitter,
  Input, model,
  OnInit,
  Output,
  Self,
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NgControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-icon-input',
  templateUrl: './icon-input.html',
  styleUrls: ['./icon-input.scss'],
  imports: [
    MatIcon,
    FormsModule,
    ReactiveFormsModule
  ],
})
export class IconInput implements OnInit, ControlValueAccessor {
  @Input() placeholder = '';
  @Input() icon = 'search';
  @Input() showClear = true;
  @Output() blur: EventEmitter<void> = new EventEmitter<void>();
  disabled!: boolean;
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  value = model('');

  constructor(@Self() public controlDir: NgControl) {
    controlDir.valueAccessor = this;
  }

  ngOnInit(): void {
    const control = this.controlDir.control;
    const validators = control?.validator
      ? [control.validator, Validators.required]
      : Validators.required;
    control?.setValidators(validators);
  }


  clearSearch() {
    this.controlDir.control?.patchValue('');
    this.value.set('');
  }

  writeValue(value: any): void {
    value && this.controlDir.control?.setValue(value, { emitEvent: false });
  }

  registerOnChange(onChange: (value: any) => void): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }
}
